import React, { Component } from 'react'
import SidePanel from '@root/Auth/Views/SidePanel'
import Logo from '@root/Auth/Views/SidePanel/logo.js'
import PropTypes from 'prop-types'
import Button from '@components/Button'

class EmailFound extends Component {
  static propTypes = {
    pageTitle: PropTypes.string,
    accept: PropTypes.func,
    back: PropTypes.func
  }

  render() {
    const { pageTitle, accept, back } = this.props
    return (
      <div className='expert-compliance'>
        <SidePanel />
        <div className='form-expert-compliance'>
          <Logo className='expert-compliance-form-logo' />
          <h1 className='form-expert-compliance__title'>{pageTitle}</h1>
          <div className='form-inner'>
            <h3 className='form-expert-compliance__title form-expert-compliance__subtitle'>
              Welcome
            </h3>
            <div className='expert-compliance-text'>
              <div>
                Your e-mail address was found in our records.
              </div>
              <div>
              </div>
              <div className='expert-compliance-form-button-section'>
                <a href onClick={back}>
                   Back
                 </a>
                <Button
                  red
                  onClick={accept}
                >
                  Continue
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default EmailFound
